import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'STATICDATAISDA/';

export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const STATIC_DATA_ISDA_LOADED = `${pre}STATIC_DATA_ISDA_LOADED`;

export const FETCH_FILTER_LIST_VALUES_ERROR = `${pre}FETCH_FILTER_LIST_VALUES_ERROR`;

export const FETCH_PRODUCT_CLASS_REQUEST = `${pre}FETCH_PRODUCT_CLASS_REQUEST`;
export const FETCH_PRODUCT_CLASS_SUCCESS = `${pre}FETCH_PRODUCT_CLASS_SUCCESS`;
export const FETCH_PRODUCT_CLASS_ERROR = `${pre}FETCH_PRODUCT_CLASS_ERROR`;

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});

export const staticDataIsdaLoaded = search => ({
    type: STATIC_DATA_ISDA_LOADED,
    search
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const fetchFilterListValuesError = error => ({
    type: FETCH_FILTER_LIST_VALUES_ERROR,
    error
});

export const fetchProductClassRequest = productClass => ({
    type: FETCH_PRODUCT_CLASS_REQUEST,
    productClass
});


export const fetchProductClassSuccess = (productClass, data, serverFilters) => ({
    type: FETCH_PRODUCT_CLASS_SUCCESS,
    productClass,
    data,
    serverFilters
});

export const fetchProductClassError = (productClass, error) => ({
    type: FETCH_PRODUCT_CLASS_ERROR,
    productClass,
    error
});

subscribe(FETCH_FILTER_LIST_VALUES_ERROR, 'Filter list value error', notificationError);
subscribe(FETCH_PRODUCT_CLASS_ERROR, 'Product class fetch error', notificationError);
